const asArray = (value) => {
	return Array.isArray(value) ? value : [value];
};

class SearchParams {
	#searchParams;
	#location;
	value = null;

	constructor(searchParams, location) {
		this.#searchParams = searchParams;
		this.#location = location;
	}

	reloadUrl(newUrl) {
		const state = this.#location.state;
		const url = `${newUrl ?? this.#location.pathname}?${this.asQueryString()}`;
		window.history.pushState(state, '', url);
	}

	get(searchParamName) {
		return new SearchResult(this.#searchParams.get(searchParamName));
	}

	set(searchParamName, searchParamValue, append = false) {
		if (append) {
			this.#searchParams.append(searchParamName, searchParamValue);
		} else {
			this.#searchParams.set(searchParamName, searchParamValue);
		}
		this.reloadUrl();
	}

	delete(searchParamName, valueToMatch) {
		this.#searchParams.delete(searchParamName, valueToMatch);
	}

	reset() {
		this.#searchParams = new URLSearchParams();
		this.reloadUrl();
	}

	asQueryString() {
		return this.#searchParams.toString();
	}

	has(searchParamName) {
		return this.#searchParams.has(searchParamName);
	}
}

class SearchResult {
	#value = null;
	#isMultiple = false;
	constructor(value) {
		this.#value = value;
		this.#isMultiple = Array.isArray(value);
	}

	asUnknown() {
		return this.#value;
	}

	asInt(defaultIntValue) {
		if (this.#isMultiple) {
			return asArray(this.#value).map((v) => parseInt(v) ?? defaultIntValue);
		}
		return parseInt(this.#value) ?? defaultIntValue;
	}

	asBoolean(defaultBooleanValue) {
		if (this.#isMultiple) {
			return asArray(this.#value).map((v) => Boolean(v) ?? defaultBooleanValue);
		}
		return Boolean(this.#value) ?? defaultBooleanValue;
	}

	asString(defaultStringValue) {
		if (this.#isMultiple) {
			return asArray(this.#value).map((v) => String(v) ?? defaultStringValue);
		}
		return String(this.#value) ?? defaultStringValue;
	}

	asNumber(defaultNumberValue) {
		if (this.#isMultiple) {
			return asArray(this.#value).map((v) => Number(v) ?? defaultNumberValue);
		}
		return Number(this.#value) ?? defaultNumberValue;
	}

	asObject(defaultObjectValue) {
		if (this.#isMultiple) {
			return asArray(this.#value).map(
				(v) => JSON.parse(v) ?? defaultObjectValue
			);
		}
		return JSON.parse(this.#value) ?? defaultObjectValue;
	}

	asArray() {
		this.#isMultiple = true;
		return this;
	}
}

export default SearchParams;
